var ForcePhoneVerificationStrategy = (function (_, $, PromiseUtil, PaymentStrategy) {

	var ForcePhoneVerificationStrategy = function (attrs) {
		PaymentStrategy.apply(this, arguments);
	};

	ForcePhoneVerificationStrategy.prototype = _.extend(window.app.jsUtils.createObjectWithProto(PaymentStrategy.prototype), {
		constructor: ForcePhoneVerificationStrategy,
        
        beforeProcess: function (method) {
            var $defer = $.Deferred(), arguments_ = arguments;

            if (method)
                method.forcePhoneVerification = true;
            else
                method = { forcePhoneVerification : true }

            $defer.resolve.apply($defer, arguments_);
            return $defer.promise();
		},

	});

	return ForcePhoneVerificationStrategy;
})(_, $, PromiseUtil, PaymentStrategy);
